import { create } from "zustand";

export const useProductStore = create((set) => ({
  indexes: {},
  groupFiltersAndDriversOptions: [],

  setProductData: (data) => set({
    indexes: data.indexes,
    groupFiltersAndDriversOptions: data.groupFiltersAndDriversOptions,
  }),
}));
